import { render, staticRenderFns } from "./DiseasePopup.vue?vue&type=template&id=1840449e&scoped=true"
import script from "./DiseasePopup.vue?vue&type=script&lang=js"
export * from "./DiseasePopup.vue?vue&type=script&lang=js"
import style0 from "./DiseasePopup.vue?vue&type=style&index=0&id=1840449e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1840449e",
  null
  
)

export default component.exports